import { cloneDeep }         from 'lodash-es';
import { Module }            from 'vuex';
import { RootState }         from '@/store/store.types';
import { XAxisReportLayout } from '@/views/x-axis-report/report-edit/types/types';
import { state }             from './state.store';
import actions               from './actions.store';
import mutations             from './mutations.store';
import getters               from './getters.store';

const store: Module<XAxisReportLayout, RootState> = {
  namespaced: true,
  state: cloneDeep(state),
  actions,
  mutations,
  getters,
};

export default store;
